import { render, staticRenderFns } from "./GridVueSelect.vue?vue&type=template&id=15f11984&scoped=true&"
import script from "./GridVueSelect.vue?vue&type=script&lang=js&"
export * from "./GridVueSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f11984",
  null
  
)

export default component.exports